import { agreementHTML } from '@webapp/landing/src/components/ru/docs/html/agreement';

import { Doc } from './doc';

export const Agreement: FC = () => (
    <Doc html={agreementHTML} subTitle='Пользовательское соглашение' title='Оферта, договоры' />
);
